function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { j as r } from "./index.es33.js";
import { useState as Y, useRef as Z, useEffect as _ } from "react";
import { clsx as p } from "./index.es105.js";
import { Typography as z } from "./index.es35.js";
import { palette as S } from "./index.es36.js";
import { Resizeable as d } from "./index.es47.js";
import "./index.es48.js";
import { inputSelectors as A } from "./index.es107.js";
import { EmojiPicker as b } from "./index.es45.js";
import { Icon as k } from "./index.es7.js";
import { InputHint as H } from "./index.es108.js";
import { useAutoSize as V } from "./index.es121.js";
import { HiddenSpan as L } from "./index.es122.js";
import { TextAreaInput as g } from "./index.es123.js";
import a from "./index.es111.js";
import e from "./index.es124.js";

var ur = function ur(_ref) {
  var _o$length, _p, _p3, _p4;

  var _ref$resizeDirection = _ref.resizeDirection,
      N = _ref$resizeDirection === void 0 ? d.ResizeDirection.all : _ref$resizeDirection,
      t = _ref.maxLength,
      o = _ref.value,
      j = _ref.onChange,
      n = _ref.isDisabled,
      s = _ref.isError,
      I = _ref.hint,
      x = _ref.isLoading,
      y = _ref.label,
      W = _ref.postfix,
      F = _ref.prefix,
      P = _ref.placeholder,
      T = _ref.onBlur,
      B = _ref.onPaste,
      l = _ref.isAutosize,
      m = _ref.minHeight,
      E = _ref.minWidth,
      w = _ref.maxHeight,
      $ = _ref.maxWidth,
      u = _ref.height,
      v = _ref.width,
      D = _ref.withCopy,
      i = _ref.isVariable,
      O = _ref.validate,
      q = _ref.options,
      G = _ref.noOptionsText,
      J = _ref.onAddVariable,
      K = _ref.isAddVariablePending,
      M = _ref.onOptionClick,
      C = _ref.isEmoji;

  var _Y = Y(!1),
      _Y2 = _slicedToArray(_Y, 2),
      h = _Y2[0],
      Q = _Y2[1],
      f = Z(null),
      _V = V({
    inputRef: f,
    isAutosize: l,
    value: o,
    minHeight: m
  }),
      U = _V.hiddenSpanRef,
      X = _V.initialWidth,
      R = _V.autoHeight;

  return _(function () {
    t && o && o.length > t && (j === null || j === void 0 ? void 0 : j(o.slice(0, t)));
  }, [o, f.current, R]), r.jsxs("div", {
    children: [r.jsxs("div", {
      className: e.labelContainer,
      children: [y && r.jsx(z.Body2, {
        as: "div",
        className: p(a.labelContainer, a.label),
        children: y
      }), !!t && r.jsxs(z.Overline, {
        className: e.symbolsCounter,
        color: S.gray6,
        children: [(_o$length = o === null || o === void 0 ? void 0 : o.length) !== null && _o$length !== void 0 ? _o$length : 0, " / ", t]
      })]
    }), r.jsxs("label", {
      className: p(a.container, (_p = {}, _defineProperty(_p, a.containerWithError, s && !n), _defineProperty(_p, a.containerDisabled, n), _p)),
      onClick: function onClick(c) {
        var _f$current;

        c.preventDefault(), (_f$current = f.current) === null || _f$current === void 0 ? void 0 : _f$current.focus();
      },
      children: [r.jsxs("div", {
        className: e.inputContainer,
        children: [r.jsx(d, {
          className: p(_defineProperty({}, e.variableResizeContainer, i)),
          resizeDirection: l ? d.ResizeDirection.none : N,
          minWidth: E,
          minHeight: m,
          maxWidth: $,
          maxHeight: w,
          height: R || u,
          width: v,
          children: r.jsxs("div", {
            className: p(e.wrapper, A.classNames.wrapper, (_p3 = {}, _defineProperty(_p3, e.wrapperLoading, x), _defineProperty(_p3, e.wrapperResizeable, N !== d.ResizeDirection.none), _defineProperty(_p3, e.wrapperResizeableVariable, i), _defineProperty(_p3, e.wrapperFocused, h && !s), _defineProperty(_p3, e.wrapperWithError, s), _p3)),
            children: [F, r.jsx(g, {
              maxHeight: w,
              minHeight: m,
              height: u,
              isLoading: x,
              isAutosize: l,
              autoHeight: R,
              isDisabled: n,
              inputRef: f,
              value: o,
              setIsFocused: Q,
              isFocused: h,
              maxLength: t,
              onChange: j,
              onBlur: T,
              onPaste: B,
              placeholder: P,
              withCopy: D,
              isVariable: i,
              validate: O,
              options: q,
              noOptionsText: G,
              onAddVariable: J,
              isAddVariablePending: K,
              onOptionClick: M,
              isEmoji: C
            })]
          })
        }), r.jsx("div", {
          className: p(e.emojiContainer, (_p4 = {}, _defineProperty(_p4, e.isVariable, i), _defineProperty(_p4, e.containerWithError, s && !n), _p4)),
          onClick: function onClick(c) {
            return c.stopPropagation();
          },
          children: C && !x && !n && r.jsx(b, {
            position: b.PositionVariants.topLeft,
            onEmojiClick: function onEmojiClick(c) {
              return j === null || j === void 0 ? void 0 : j("".concat(o || "").concat(c));
            },
            children: r.jsx(k, {
              icon: k.icons.outline.smile,
              size: 16,
              color: S.gray6
            })
          })
        })]
      }), r.jsx(H, {
        isError: s,
        hint: I
      }), W, r.jsx(L, {
        isAutosize: l,
        hiddenSpanRef: U,
        minHeight: m,
        height: u,
        initialWidth: X,
        value: o,
        isVariable: i
      })]
    })]
  });
};

export { ur as Textarea };